
//put all valid types for upload
export const types = [
  'pdf',
  'png',
  'jpeg',
  'jpg',
  'kmz',
  'kml',
  'dwg',
  'dwf',
  'xls',
  'xlsx',
];
export const imgTypes = [
  'png',
  'jpeg',
  'jpg',
];


export const typesForSelectedList = {
  'application/pdf': "pdf",
  'image/png': "png",
  'image/jpeg': "jpeg",
  'image/jpg': "jpg",
  'kmz': "kmz",
  'kml': "kml",
  'dwg': "dwg",
  'dwf': 'dwf',
  'application/vnd.ms-excel': "xls",
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': "xlsx",
  'xls': 'xls',
  'xlsx': 'xlsx'
};


export const typesForExcel = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};